import { Route, Routes } from "react-router-dom";

import {
  
  ForgotPassword,
  SignIn,
  SignUp,
} from "../../pages";

export const AuthLayout = () => {
  return (
    <Routes>
      <Route path="*" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
};
